export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL
export const FRONT_BASE_URL = process.env.NEXT_PUBLIC_FRONT_BASE_URL
export const MOCK_DATA = process.env.NEXT_PUBLIC_MOCK_DATA === 'true'

export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID as string

export const KEY = {
  GF_CONSUMER_KEY: process.env.NEXT_PUBLIC_GF_CONSUMER_KEY,
  GF_CONSUMER_SECRET: process.env.NEXT_PUBLIC_GF_CONSUMER_SECRET
}

export const API = {
  BASE: '/wp-json/wp/v2',
  SEARCH: '/wp-json/gusto/search',
  ROUTES: '/wp-json/gusto/routes',
  STRINGS: '/wp-json/gusto/options',
  MENU_LOCATIONS: '/wp-json/gusto/nav/menu-locations',
  GRAVITY_FORM: '/wp-json/gf/v2/forms',
  COLOR_SEARCH: '/wp-json/decora/v1/colors/search'
}

export const MediaQuery = {
  SMALL: '(max-width: 767px)',
  MEDIUM: '(min-width: 768px)',
  LARGE: '(min-width: 1024px)',
  TOUCH: '(pointer: coarse)',
  POINTER: '(hover: hover) and (pointer: fine)'
}
